<div
  class="container mt-4 mb-5 new-order-container"
  [class.copy-pedido]="isCopy"
  [class.copy-pedido--themed]="isCopy && copyAccent"
  [ngStyle]="copyAccent ? { '--copy-accent': copyAccent } : null"
>
  <h4 i18n>{{ isCopy ? "Copia Pedido" : "Novo Pedido" }}</h4>
  <div *ngFor="let e of errorMsg" class="alert alert-primary" role="alert">
    {{ e }}
  </div>

  <form
    class="new-order-form"
    (ngSubmit)="isCopy ? onCopySubmit() : onSubmit()"
    [formGroup]="form"
  >
    <ng-container *ngIf="isCopy; else novoPedidoLayout">
      <section class="copy-step">
        <header class="copy-step-head">
          <span class="copy-step-num">1</span>
          <div>
            <h5>Dados do cliente</h5>
            <p>Busque e confirme o cliente e o endereço de entrega</p>
          </div>
        </header>

        <div class="copy-card">
          <app-typeahead
            [onType]="searchFunction"
            [options]="results"
            [onOptionClick]="handleSelectionCopy"
            [loading]="buscandoClientes"
            [disabled]="listCliente.length >= 1"
            [showSearchIcon]="true"
            placeholder="Digite o nome, código ou CNPJ do cliente"
          ></app-typeahead>

          <div class="cliente-status-area mt-2" aria-live="polite">
            <div *ngIf="buscandoClientes" class="cliente-status-msg cliente-status-msg-loading" i18n>
              Aguarde, buscando cliente...
            </div>
            <div
              *ngIf="!buscandoClientes && clienteSelecionado && (errorClienteBloqueado || !clienteIntegrado)"
              class="cliente-status-msg cliente-status-msg-nao-integrado"
            >
              <ng-container *ngIf="errorClienteBloqueado && erroMensagemBloqueio; else textoNaoIntegradoCopy">
                {{ erroMensagemBloqueio }}
              </ng-container>
              <ng-template #textoNaoIntegradoCopy>
                <span i18n>Cliente não integrado.</span>
              </ng-template>
            </div>
          </div>

          <div *ngIf="noResult" class="alert alert-info mt-2 mb-0" i18n>
            Nenhum registro encontrado!
          </div>

          <div *ngIf="clienteDetalheCarregando" class="copy-cliente-grid mt-3">
            <div class="copy-dado" *ngFor="let _ of [1, 2, 3, 4, 5]">
              <div class="cliente-sk-label"></div>
              <div class="cliente-sk-value"></div>
            </div>
          </div>

          <ng-container *ngIf="!clienteDetalheCarregando && clienteSelecionado">
            <div *ngIf="errorClienteTabela" class="alert alert-danger mt-3 mb-0" i18n>
              Clientes com tabela de preço diferente!
            </div>
            <div class="copy-cliente-grid">
              <div class="copy-dado">
                <svg class="copy-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true">
                  <path d="M7 3h8l5 5v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z"/>
                  <path d="M15 3v5h5"/>
                  <path d="M9 13h6M9 17h4"/>
                </svg>
                <div>
                  <small>Código</small>
                  <strong>{{ selectedCliente.codigo }}</strong>
                </div>
              </div>
              <div class="copy-dado">
                <svg class="copy-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true">
                  <path d="M4 20V8l8-5 8 5v12"/>
                  <path d="M9 20v-6h6v6"/>
                </svg>
                <div>
                  <small>Nome</small>
                  <strong>{{ selectedCliente.nome }}</strong>
                </div>
              </div>
              <div class="copy-dado">
                <svg class="copy-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true">
                  <circle cx="12" cy="8" r="3.2"/>
                  <path d="M5.5 19c.8-3.2 3.3-5 6.5-5s5.7 1.8 6.5 5"/>
                </svg>
                <div>
                  <small>Fantasia</small>
                  <strong>{{ selectedCliente.fantasia }}</strong>
                </div>
              </div>
              <div class="copy-dado">
                <svg class="copy-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true">
                  <rect x="3.5" y="5.5" width="17" height="13" rx="2"/>
                  <path d="M4 7l8 6 8-6"/>
                </svg>
                <div>
                  <small>E-mail</small>
                  <strong>{{ selectedCliente.email }}</strong>
                </div>
              </div>
              <div class="copy-dado" *ngIf="selectedCliente.cidades">
                <svg class="copy-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true">
                  <path d="M12 21s7-6.2 7-11a7 7 0 1 0-14 0c0 4.8 7 11 7 11z"/>
                  <circle cx="12" cy="10" r="2.2"/>
                </svg>
                <div>
                  <small>Cidade</small>
                  <strong [style.color]="selectedCliente.cidades.nome === null ? 'red' : null">
                    {{ selectedCliente.cidades.nome }}{{ selectedCliente.cidades.uf === "0" ? "" : " - " + selectedCliente.cidades.uf }}
                  </strong>
                </div>
              </div>
            </div>

            <p class="copy-endereco-titulo">Endereço de entrega</p>
            <div
              *ngIf="selectedCliente.enderecos && selectedCliente.enderecos.length > 0; else copyEnderecoElse"
              class="copy-enderecos"
            >
              <button
                type="button"
                class="copy-endereco"
                *ngFor="let a of selectedCliente.enderecos"
                [class.ativo]="clienteIdErp[selectedCliente.id] == a.id"
                (click)="select(a.id)"
              >
                <span class="copy-radio" [class.ativo]="clienteIdErp[selectedCliente.id] == a.id"></span>
                <span>
                  <strong>{{ textoEndereco(a) }}</strong>
                  <small>{{ textoEnderecoComplemento(a) }}</small>
                </span>
              </button>
            </div>
            <ng-template #copyEnderecoElse>
              <div class="copy-enderecos" *ngIf="selectedCliente.enderecos">
                <button
                  type="button"
                  class="copy-endereco"
                  [class.ativo]="true"
                  (click)="select(selectedCliente.idEnderecoErp)"
                >
                  <span class="copy-radio ativo"></span>
                  <span>
                    <strong>{{ selectedCliente.endereco }} {{ selectedCliente.numero }}</strong>
                    <small>
                      {{ selectedCliente.bairro }}
                      {{ selectedCliente.uf }} - {{ selectedCliente.descricao }}
                      {{ selectedCliente.cep }}
                    </small>
                  </span>
                </button>
              </div>
            </ng-template>
          </ng-container>
        </div>
      </section>

      <section class="copy-step">
        <header class="copy-step-head">
          <span class="copy-step-num">2</span>
          <div>
            <h5>Dados do pedido</h5>
            <p>Documento de faturamento e tipo de pedido</p>
          </div>
        </header>

        <div class="copy-card copy-card-pedido">
          <div class="copy-badges" *ngIf="listCliente.length">
            <span class="copy-badges-label">CNPJ / CPF</span>
            <span
              *ngFor="let c of listCliente"
              class="copy-badge"
              tooltip="{{ c['cliente' + SITE.identificacaoCliente] }}"
              placement="bottom"
            >
              {{ documentoCliente(c) || c[SITE.identificacaoCliente] }}
              <button
                type="button"
                class="copy-badge-x"
                (click)="excluiClienteCopy(c)"
                aria-label="Remover cliente"
                title="Remover cliente"
              >
                <i class="icofont-close"></i>
              </button>
            </span>
          </div>

          <div class="row copy-pedido-fields">
            <div class="col-12 col-md-6 col-xl-4" *ngIf="pedidoTiposUsuario.length > 0">
              <div class="form-group mb-0">
                <label>{{ SITE.labelPedidoTipo }}</label>
                <select
                  id="pedidoTipo"
                  formControlName="pedidoTipo"
                  class="form-control"
                  [(ngModel)]="tipoSelecionado"
                  (change)="getTabela($event.target.value)"
                >
                  <option value="0"></option>
                  <option *ngFor="let t of pedidoTiposUsuario" value="{{ t.id }}">
                    {{ t.tipo }} - {{ t.descricao }}
                  </option>
                </select>
                <div *ngIf="error && form.get('pedidoTipo').invalid" class="error" i18n>
                  Verifique este campo!
                </div>
              </div>
            </div>

            <div class="col-12 col-md-6 col-xl-4" *ngIf="filiais.length > 0">
              <div class="form-group mb-0">
                <label>{{ SITE.labelFilial }}</label>
                <select id="filial" formControlName="filial" class="form-control">
                  <option value=""></option>
                  <option *ngFor="let f of filiais" value="{{ f.id }}">
                    {{ f.codigo }} - {{ f.descricao }}
                  </option>
                </select>
                <div *ngIf="error && form.get('filial').invalid" class="error" i18n>
                  Verifique este campo!
                </div>
              </div>
            </div>

            <div class="col-12 col-md-6 col-xl-4" *ngIf="tabelas.length > 0">
              <div class="form-group mb-0">
                <label>{{ SITE.labelTabela }}</label>
                <select
                  id="tabela"
                  formControlName="tabela"
                  class="form-control"
                  [compareWith]="compareIds"
                >
                  <option [ngValue]="''"></option>
                  <option *ngFor="let t of tabelas" [ngValue]="t.id">
                    {{ t.codigo }} - {{ t.descricao }}
                  </option>
                </select>
                <div *ngIf="error && form.get('tabela').invalid" class="error" i18n>
                  Verifique este campo!
                </div>
              </div>
            </div>

            <div class="col-12 col-md-6 col-xl-4" *ngIf="filial_Estoque.length > 1">
              <div class="form-group mb-0">
                <label>Filial de estoque</label>
                <select id="filialEstoque" formControlName="filialEstoque" class="form-control">
                  <option value="0"></option>
                  <option *ngFor="let t of filial_Estoque" value="{{ t.id }}">
                    {{ t.codigo }} - {{ t.descricao }}
                  </option>
                </select>
                <div *ngIf="error && form.get('filialEstoque').invalid" class="error" i18n>
                  Verifique este campo!
                </div>
              </div>
            </div>

            <div class="col-12 col-md-6 col-xl-4" *ngIf="SITE.mostraDataEntrega">
              <div class="form-group mb-0">
                <label>Data de Entrega</label>
                <input
                  type="text"
                  class="form-control"
                  bsDatepicker
                  formControlName="dataEntrega"
                  [minDate]="dataEntregaMinDate"
                  [daysDisabled]="dataEntregaDaysDisable"
                  [bsConfig]="{
                    isAnimated: true,
                    dateInputFormat: dateFormat,
                    adaptivePosition: true
                  }"
                />
                <div *ngIf="error && form.get('dataEntrega').invalid" class="error" i18n>
                  Verifique este campo!
                </div>
              </div>
            </div>

            <div class="col-12">
              <div class="form-group mb-0">
                <label>Observação</label>
                <textarea
                  class="form-control"
                  formControlName="observacao"
                  rows="3"
                  maxlength="500"
                  placeholder="Opcional"
                ></textarea>
              </div>
            </div>
          </div>

          <footer class="copy-footer">
            <p>Revise os dados antes de continuar.</p>
            <button
              type="submit"
              class="btn btn-primary btn-lg new-order-submit-button"
              [disabled]="abrirPedidoDisabled || errorClienteBloqueado"
              [attr.aria-busy]="abrindoPedido ? 'true' : null"
            >
              <ng-container *ngIf="abrindoPedido; else abrirPedidoLabelCopy">
                <span
                  class="spinner-border spinner-border-sm new-order-submit-spinner"
                  role="status"
                  aria-hidden="true"
                ></span>
                <span i18n>Abrindo pedido...</span>
              </ng-container>
              <ng-template #abrirPedidoLabelCopy>
                <i class="icofont-cart"></i>
                <span i18n>Abrir Pedido</span>
                <i class="icofont-arrow-right"></i>
              </ng-template>
            </button>
          </footer>
        </div>
      </section>
    </ng-container>

    <ng-template #novoPedidoLayout>
      <div class="row">
        <div class="col-12 px-0">
          <div class="form-group mb-1">
            <label>{{ SITE.labelCliente }}</label>
            <app-typeahead
              [onType]="searchFunction"
              [options]="results"
              [onOptionClick]="handleSelection"
              [loading]="buscandoClientes"
              [disabled]="!abrePedidoEmGrupo && listCliente.length >= 1"
            ></app-typeahead>
          </div>

          <div class="cliente-status-area mb-2" aria-live="polite">
            <div class="cliente-status-shell">
              <div class="cliente-status-slot">
                <div *ngIf="buscandoClientes" class="cliente-status-msg cliente-status-msg-loading" i18n>
                  Aguarde, buscando cliente...
                </div>
                <div
                  *ngIf="!buscandoClientes && clienteSelecionado && (errorClienteBloqueado || !clienteIntegrado)"
                  class="cliente-status-msg cliente-status-msg-nao-integrado"
                >
                  <ng-container *ngIf="errorClienteBloqueado && erroMensagemBloqueio; else textoNaoIntegrado">
                    {{ erroMensagemBloqueio }}
                  </ng-container>
                  <ng-template #textoNaoIntegrado>
                    <span i18n>Cliente não integrado.</span>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="noResult" class="alert alert-info" i18n>
        Nenhum registro encontrado!
      </div>

      <div class="row new-order-main gx-0 gy-3">
        <div class="col-12 new-order-col-cliente px-0">
          <div
            *ngIf="!clienteSelecionado && !clienteDetalheCarregando"
            class="card card-block card-header p-0 mb-3"
          >
            <div class="alert m-3" i18n>Selecione um ou mais!</div>
          </div>
          <div
            *ngIf="clienteSelecionado || clienteDetalheCarregando"
            class="card card-block card-header p-0 mb-2"
          >
            <div *ngIf="clienteDetalheCarregando" class="cliente-detalhe-skeleton-wrap p-3">
              <div class="row pt-2">
                <div class="col-12 col-lg-4">
                  <div class="form-group mb-1" *ngFor="let _ of [1, 2]">
                    <div class="cliente-sk-label"></div>
                    <div class="cliente-sk-value"></div>
                  </div>
                </div>
                <div class="col-12 col-lg-4">
                  <div class="form-group mb-1" *ngFor="let _ of [1, 2]">
                    <div class="cliente-sk-label"></div>
                    <div class="cliente-sk-value cliente-sk-value-lg"></div>
                  </div>
                </div>
                <div class="col-12 col-lg-4">
                  <div class="form-group mb-1 invisible">
                    <div class="cliente-sk-label"></div>
                    <div class="cliente-sk-value"></div>
                  </div>
                  <div class="form-group mb-1">
                    <div class="cliente-sk-label"></div>
                    <div class="cliente-sk-value cliente-sk-value-md"></div>
                  </div>
                </div>
              </div>
              <div class="cliente-sk-enderecos mt-1">
                <div class="cliente-sk-th"></div>
                <div class="cliente-sk-addr-row" *ngFor="let _ of [1, 2]">
                  <div class="cliente-sk-radio"></div>
                  <div class="cliente-sk-addr-text">
                    <div class="cliente-sk-value cliente-sk-value-lg mb-2"></div>
                    <div class="cliente-sk-value cliente-sk-value-sm"></div>
                  </div>
                </div>
              </div>
            </div>
            <ng-container *ngIf="!clienteDetalheCarregando && clienteSelecionado">
              <div *ngIf="errorClienteTabela" class="alert alert-danger mb-2" i18n>
                Clientes com tabela de preço diferente!
              </div>
              <div class="row pt-2">
                <div class="col-12 col-lg-4">
                  <div class="form-group mb-1">
                    <label i18n>Código</label><br />
                    <b>{{ selectedCliente.codigo }}</b>
                  </div>
                  <div class="form-group mb-1">
                    <label i18n>Email</label><br />
                    <b>{{ selectedCliente.email }}</b>
                  </div>
                  <div
                    class="form-group mb-1"
                    *ngIf="selectedCliente.limite_disponivel !== null"
                  >
                    <label i18n>limite de crédito disponível</label><br />
                    <b *ngIf="selectedCliente.limite_disponivel !== null"
                      >R$
                      {{
                        selectedCliente.limite_disponivel | currency : "BRL" : ""
                      }}</b
                    >
                  </div>
                </div>

                <div class="col-12 col-lg-4">
                  <div class="form-group mb-1">
                    <label i18n>Nome</label><br />
                    <b>{{ selectedCliente.nome }}</b>
                  </div>
                  <div class="form-group mb-1">
                    <label i18n>Fantasia</label><br />
                    <b>{{ selectedCliente.fantasia }}</b>
                  </div>
                </div>

                <div class="col-12 col-lg-4" *ngIf="selectedCliente.cidades">
                  <div class="form-group mb-1 invisible">
                    <label i18n>Nome</label><br />
                    <b>&nbsp;</b>
                  </div>
                  <div
                    class="form-group mb-1"
                    [style.color]="selectedCliente.cidades.nome === null ? 'red' : ''"
                  >
                    <label i18n>Cidade</label><br />
                    <b>
                      {{ selectedCliente.cidades.nome }}{{ selectedCliente.cidades.uf === "0" ? "" : " - " + selectedCliente.cidades.uf }}
                    </b>
                  </div>
                </div>
              </div>
              <div
                *ngIf="selectedCliente.enderecos  && selectedCliente.enderecos.length > 0; else enderecoElseBlock"
                class="row"
              >
                <table class="table table-hover table-condensed mb-0">
                  <thead>
                    <tr>
                      <th colspan="2" i18n>Selecione um endereço</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="let a of selectedCliente.enderecos; index as i"
                      (click)="select(a.id)"
                    >
                      <td style="width: 40px">
                        <div
                          class="mt-1 {{
                            clienteIdErp[selectedCliente.id] == a.id
                              ? 'selected-radio'
                              : 'unselected-radio'
                          }}"
                        >
                          <div
                            *ngIf="clienteIdErp[selectedCliente.id] == a.id"
                            class="selected-radio-inside"
                          ></div>
                        </div>
                      </td>
                      <td>
                        <h6 i18n>{{ a.endereco }} {{ a.numero }}</h6>
                        {{ a.uf === "0" ? "" : a.uf+" - "}}{{ a.descricao }} {{ a.cep === "" ? "":"("+ a.cep+")" }}
                        {{ a.bairro ==="" ? "" : ","+a.bairro}}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <ng-template #enderecoElseBlock>
                <table
                  *ngIf="selectedCliente.enderecos"
                  class="table table-hover table-condensed mb-0"
                >
                  <thead>
                    <tr>
                      <th colspan="2" i18n>Selecione um endereço</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style="width: 40px">
                        <input
                          type="radio"
                          value="{{ selectedCliente.idEnderecoErp }}"
                          [(ngModel)]="clienteIdErp[selectedCliente.id]"
                          [ngModelOptions]="{ standalone: true }"
                          [checked]="selectedCliente.enderecos.length === 1"
                          [defaultChecked]="selectedCliente.enderecos.length === 1"
                        />
                      </td>
                      <td>
                        <h6>
                          {{ selectedCliente.endereco }}
                          {{ selectedCliente.numero }}
                        </h6>
                        {{ selectedCliente.uf }} -
                        {{ selectedCliente.descricao }} ({{ selectedCliente.cep }}),
                        {{ selectedCliente.bairro }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </ng-template>
            </ng-container>
          </div>
          <div id="clientes" *ngIf="listCliente.length" class="mb-3 mt-2">
            <span
              *ngFor="let c of listCliente"
              class="badge badge-primary"
              tooltip="{{ c['cliente' + SITE.identificacaoCliente] }}"
              placement="bottom"
            >
              <span (click)="selecionaCliente(c)" class="descr">{{
                c[SITE.identificacaoCliente]
              }}</span>
              <span class="badge badge-light" (click)="excluiCliente(c)">X</span>
            </span>
          </div>

          <div class="card card-block card-header new-order-pedido-card">
            <div class="p-3">
              <div class="row new-order-pedido-fields g-2">
                <div class="col-12 col-md-6 col-xl-4" *ngIf="pedidoTiposUsuario.length > 1">
                  <div class="form-group mb-0">
                    <label>{{ SITE.labelPedidoTipo }}</label>
                    <select
                      id="pedidoTipoNovo"
                      formControlName="pedidoTipo"
                      class="form-control"
                      [(ngModel)]="tipoSelecionado"
                      (change)="getTabela($event.target.value)"
                    >
                      <option value="0"></option>
                      <option *ngFor="let t of pedidoTiposUsuario" value="{{ t.id }}">
                        {{ t.tipo }} - {{ t.descricao }}
                      </option>
                    </select>
                    <div
                      *ngIf="error && form.get('pedidoTipo').invalid"
                      class="error"
                      i18n
                    >
                      Verifique este campo!
                    </div>
                  </div>
                </div>

                <div class="col-12 col-md-6 col-xl-4" *ngIf="filiais.length > 1">
                  <div class="form-group mb-0">
                    <label>{{ SITE.labelFilial }}</label>
                    <select id="filialNovo" formControlName="filial" class="form-control">
                      <option value=""></option>
                      <option *ngFor="let f of filiais" value="{{ f.id }}">
                        {{ f.codigo }} - {{ f.descricao }}
                      </option>
                    </select>
                    <div *ngIf="error && form.get('filial').invalid" class="error" i18n>
                      Verifique este campo!
                    </div>
                  </div>
                </div>

                <div class="col-12 col-md-6 col-xl-4" *ngIf="tabelas.length > 1">
                  <div class="form-group mb-0">
                    <label>{{ SITE.labelTabela }}</label>
                    <select id="tabelaNovo" formControlName="tabela" class="form-control">
                      <option value=""></option>
                      <option *ngFor="let t of tabelas" value="{{ t.id }}">
                        {{ t.codigo }} - {{ t.descricao }}
                      </option>
                    </select>
                    <div *ngIf="error && form.get('tabela').invalid" class="error" i18n>
                      Verifique este campo!
                    </div>
                  </div>
                </div>

                <div class="col-12 col-md-6 col-xl-4" *ngIf="filial_Estoque.length > 1">
                  <div class="form-group mb-0">
                    <label>Filial de estoque</label>
                    <select
                      id="filialEstoqueNovo"
                      formControlName="filialEstoque"
                      class="form-control"
                    >
                      <option value="0"></option>
                      <option *ngFor="let t of filial_Estoque" value="{{ t.id }}">
                        {{ t.codigo }} - {{ t.descricao }}
                      </option>
                    </select>
                    <div
                      *ngIf="error && form.get('filialEstoque').invalid"
                      class="error"
                      i18n
                    >
                      Verifique este campo!
                    </div>
                  </div>
                </div>

                <div class="col-12 col-md-6 col-xl-4" *ngIf="SITE.mostraDataEntrega">
                  <div class="form-group mb-0">
                    <label>Data de Entrega</label>
                    <input
                      type="text"
                      class="form-control"
                      bsDatepicker
                      formControlName="dataEntrega"
                      [minDate]="dataEntregaMinDate"
                      [daysDisabled]="dataEntregaDaysDisable"
                      [bsConfig]="{
                        isAnimated: true,
                        dateInputFormat: dateFormat,
                        adaptivePosition: true
                      }"
                    />
                    <div
                      *ngIf="error && form.get('dataEntrega').invalid"
                      class="error"
                      i18n
                    >
                      Verifique este campo!
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="new-order-form-footer">
        <button
          type="submit"
          class="btn btn-primary btn-lg new-order-submit-button"
          [disabled]="abrirPedidoDisabled || errorClienteBloqueado"
          [attr.aria-busy]="abrindoPedido ? 'true' : null"
        >
          <ng-container *ngIf="abrindoPedido; else abrirPedidoLabel">
            <span
              class="spinner-border spinner-border-sm new-order-submit-spinner"
              role="status"
              aria-hidden="true"
            ></span>
            <span i18n>Abrindo pedido...</span>
          </ng-container>
          <ng-template #abrirPedidoLabel>
            <span i18n>Abrir Pedido</span>
          </ng-template>
        </button>
      </div>
    </ng-template>
  </form>
</div>
